export interface TopTransfer {
    id: string;
    rank: number;
    timestamp: string;
    transaction_hash: string;
    usd_amount: number;
    network_slug: string;
    network_name: string;
    network_icon_url: string;
    asset_ticker: string;
    asset_name: string;
    asset_icon: string;
}

export interface TopTransfersData {
    seven_day: {
        under_100k: TopTransfer[];
        under_1m: TopTransfer[];
        under_10m: TopTransfer[];
        under_100m: TopTransfer[];
    };
    thirty_day: {
        under_100k: TopTransfer[];
        under_1m: TopTransfer[];
        under_10m: TopTransfer[];
        under_100m: TopTransfer[];
    };
}

export enum TopTransferColumns {
    rank = "rank",
    asset = "asset",
    timestamp = "timestamp",
    usdAmount = "usdAmount",
    network = "network",
}
